// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentItem_container__31q6M","icon":"DocumentItem_icon__1bqyI"};